var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"fill-height"},[_c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"align-content":"center","flex":"","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" You have been logged out or you do not have permissions. ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }